"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _GridAreaContainer = _interopRequireDefault(require("@sprinx/react-mui-components/GridAreaContainer"));

var _useConsolidatedParams = _interopRequireDefault(require("@sprinx/react-products/useConsolidatedParams"));

var _ProductParametersInline = _interopRequireDefault(require("@sprinx/react-com/ProductParametersInline"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../../withNullIfStaticBuild"));

var _ProductDetailInfoField = _interopRequireDefault(require("./ProductDetailInfoField"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme*/
    {
      root: {
        display: 'flex'
      }
    }
  );
}, {
  name: 'ProductDetailInfo'
});

function ProductDetailInfo(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      renderToGridArea = _ref.renderToGridArea,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product", "renderToGridArea"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var parameters = (0, _useConsolidatedParams.default)({
    translationPrefix: 'com/product'
  }, product);
  var warranty = parameters.find(function (p) {
    return p.code === '_warranty';
  });
  var nextWarranty = (0, _extends2.default)({}, warranty, {
    code: 'warranty',
    label: t('com/product/warranty/label'),
    unit: t('com/product/warranty/months')
  }); // TODO nastavit

  var nParameters = [].concat((0, _toConsumableArray2.default)(parameters), [nextWarranty]);
  var nextParameters = nParameters.filter(function (i) {
    return ['warranty', '/sku'].find(function (k) {
      return k === i.code;
    });
  }) || [];
  return /*#__PURE__*/_react.default.createElement(_GridAreaContainer.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className),
    renderToGridArea: renderToGridArea
  }), /*#__PURE__*/_react.default.createElement(_ProductParametersInline.default, {
    parameters: nextParameters,
    componentMap: {
      string: _ProductDetailInfoField.default,
      number: _ProductDetailInfoField.default
    }
  }));
}

process.env.NODE_ENV !== "production" ? ProductDetailInfo.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    parameters: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  }).isRequired,
  renderToGridArea: _propTypes.default.string
} : void 0;
ProductDetailInfo.defaultProps = {
  classes: undefined,
  className: undefined,
  renderToGridArea: 'info'
}; // remowe with withNullIfStaticBuild once moved to `razzle + after`

var _default = (0, _withNullIfStaticBuild.default)(ProductDetailInfo);

exports.default = _default;